import { CampusIcon } from '@cmp-src/icons/TacticIcons/CampusIcon';
import { DotIcon } from '@cmp-src/icons/TacticIcons/DotIcon';
import React from 'react';
import { cn } from '@gettactic/helpers';

export type ResourceLocationProps =  {
  location?: string;
  floor?: string;
  area?: string;
  withIcon?: boolean;
  className?: string;
}

export const ResourceLocation = React.memo(
  ({
    location,
    floor,
    area,
    withIcon = true,
    className,
  }: ResourceLocationProps) => {
    const floorPart = floor ? (
      <>
        <DotIcon />
        {floor}
      </>
    ) : (
      ''
    );

    const areaPart = area ? (
      <>
        <DotIcon />
        {area}
      </>
    ) : (
      ''
    );

    return (
      <div className={cn("flex items-center gap-1 text-xs", className)}>
        {withIcon && <CampusIcon
          className={
            className
          }
        />} {location || 'Office'} {floorPart}{' '}
        {areaPart}
      </div>
    );
  }
);
